const API_BASE = (process.env.REACT_APP_API_URL || '/api').replace(/\/+$/, '');

export async function fetchJson(path, options) {
  const response = await fetch(`${API_BASE}${path}`, options);
  let data;
  try {
    data = await response.json();
  } catch {
    if (response.status === 401 || response.status === 403) {
      throw new Error('Sign in with a GitHub account invited to the admin role.');
    }
    throw new Error(`The server returned an invalid response (${response.status || 'unknown status'}).`);
  }
  if (!response.ok) {
    const message = typeof data?.detail === 'string' ? data.detail : data?.error;
    if (typeof message !== 'string' && (response.status === 401 || response.status === 403)) {
      throw new Error('Sign in with a GitHub account invited to the admin role.');
    }
    throw new Error(typeof message === 'string' ? message : `Request failed (${response.status}). Please try again.`);
  }
  return data;
}
